<template>
	<div>
		<AppDialogManager />
		<InAppHelp v-if="isInAppHelpEnabled" :isGuidedTutorialOn="isGuidedTutorialOn" :isFlowBuilder="isFlowBuilder" />
		<GuidedTutorials :isFlowBuilder="isFlowBuilder" />
		<InspirationCenter />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isInAppHelpEnabled } from '@/store/modules/featureFlags/getters';
import { isGuidedTutorialOn } from '@/store/modules/onboarding/getters';

import AppDialogManager from '@/components/dialogs/AppDialogManager/AppDialogManager';
import InAppHelp from '@/components/InAppHelp/InAppHelp';
import InspirationCenter from '@/components/InspirationCenter/InspirationCenter';
import GuidedTutorials from '@/components/Onboarding/GuidedTutorials/GuidedTutorials';
import { isRouteOrChildOfRoute } from '@/utils/helpers.js';
export default {
	name: 'InAppInjectables',
	components: {
		AppDialogManager,
		InAppHelp,
		GuidedTutorials,
		InspirationCenter,
	},
	computed: {
		...mapGettersShorthand({ isGuidedTutorialOn }),
		...mapGetters([isInAppHelpEnabled.fullPath]),
		isInAppHelpEnabled() {
			return this[isInAppHelpEnabled.fullPath];
		},
		isFlowBuilder() {
			return isRouteOrChildOfRoute(this.$route, 'Feature');
		},
	},
};
</script>

<style scoped lang="scss"></style>
